// The bar that promotes the next event. Whether it shows is decided by an inline script next to it,
// before the first paint. This part only remembers that it got closed.

const bar = document.querySelector<HTMLElement>("[data-eventbar]");
if (bar != null) {
	bar.querySelector(".eventbar__close")?.addEventListener("click", () => {
		bar.hidden = true;
		document.documentElement.classList.remove("has-eventbar");

		try {
			localStorage.setItem("eventbar-closed", bar.dataset.eventbar ?? "");
		} catch {
			// no storage, e.g. in private mode: the bar comes back with the next page
		}
	});
}
